import PropTypes from 'prop-types';
import React from 'react';

import Chip, {ChipSize} from 'ui-library/chips/Chip';
import {BasicEvent} from 'util/Types';

export interface NoAccessChipProps {
  className?: string;
  onKeyDown?: (e: BasicEvent) => void;
  onRemove?: ((e: BasicEvent) => void) | null;
  size: ChipSize;
}

export const NO_ACCESS_CHIP_TEXT = '(No access)';

export default function NoAccessChip(props: NoAccessChipProps): JSX.Element {
  return <Chip {...props} text={NO_ACCESS_CHIP_TEXT} />;
}

NoAccessChip.propTypes = {
  className: PropTypes.string,
  onKeyDown: PropTypes.func,
  onRemove: PropTypes.func,
  size: PropTypes.oneOf(Object.values(ChipSize)).isRequired,
};
